$(function(){
    var modalSettingId = null;
    var menuitemIdSetting = null;
    if($("#module-modal-settings").length) {
        modalSettingId = $("#module-modal-settings").attr("data-modal-id");
    }

    var $modal = $("#module-modal-settings");
    var $body  = $modal.find(".modal-body");

    function placeChartsInSystem(data, $loading, $content) {
        $content.html(data.content);
        setTimeout(function(){
            $content.slideDown(200, function(){
                setTimeout(function(){
                    $loading.fadeOut(500, function(){ $(this).remove(); });
                },100);
            });
        },100);
    }

    $("a[data-modal-settings-modal]").on("click",function(e) {
        e.preventDefault();
        $body.html('<div class="loading-charts-place"></div><div class="modal-sub-content"></div>');
        var $loading = $body.find(".loading-charts-place");
        $body.find(".modal-sub-content").hide();
        $modal.modal('show');
        $menuitem_id = $(this).attr("data-modal-settings-menuitem-id");
        $params = {};
        if($menuitem_id) {
            $params.menuitem_id = $menuitem_id;
        }
        $.getJSON("/modal-settings/"+modalSettingId,$params, function(response){
            if(response.success) {
                placeChartsInSystem(response, $loading, $body.find(".modal-sub-content"));
            }else{
                ErrorMessage(response.message);
                $modal.modal('hide');
            }
        });
        return false;
    });

    $("body").on("click",".apply-modal-settings", function(e) {
        e.preventDefault();

        var url = $(this).closest(".modal-content").find("form").attr("action");
        var form = new FormData($(this).closest(".modal-content").find("form").closest("form")[0]);
        $.ajax({
            url: url,
            data: form,
            processData: false,
            contentType: false,
            type: 'POST',
            success: function(response){
                if(response && response.success) {
                    SuccessMessage(response.message);
                    GlobalManager.trigger('reload');
                    $modal.modal('hide');
                }else{
                    ErrorMessage(response.message);
                }
            }
        });

        return false;
    });
});